import { Modal } from "@smart/itops-sb-design-system-dom";

const modalContent = {
  delete: {
    header: "Delete Name field?",
    content: (
      <>
        <p>
          Deleting this name field will stop new form submissions from
          automatically creating a lead in Smokeball.
        </p>
        <p>
          You&apos;ll be notified and can review the submitted form in the
          Intake Dashboard, where you can manually enter the prospects name to
          create the lead.
        </p>
        <p>
          If a name field is added again later, automatic lead creation will
          resume.
        </p>
      </>
    ),
    actionButtonText: "Delete Field",
  },
  notRequired: {
    header: "Make Name field optional?",
    content: (
      <>
        <p>
          Making this field optional will stop automatic lead creation if the
          prospect does not provide a name.
        </p>
        <p>
          You&apos;ll be notified and can review the submitted form in the
          Intake Dashboard, where you can manually enter the prospects name to
          create the lead.
        </p>
        <p>
          If the field is made required again, automatic lead creation will
          resume.
        </p>
      </>
    ),
    actionButtonText: "Turn Off Required",
  },
};

type ModifyNameFieldModalProps = {
  type: "delete" | "notRequired";
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

export const ModifyNameFieldModal = ({
  type,
  open,
  loading,
  onClose,
  onConfirm,
}: ModifyNameFieldModalProps) => (
  <Modal
    dataTestId={`modify-name-field-modal-${type}`}
    header={{
      text: modalContent[type].header,
      icon: "solidGlobe",
      iconBgColor: "bg-orange-200",
    }}
    open={open}
    onClose={onClose}
    loading={loading}
    closeOptions={{
      escapeKey: false,
      clickOutside: false,
    }}
    footer={{
      buttons: [
        {
          text: "Cancel",
          type: "button",
          variant: "secondarySubtle",
          disabled: loading,
          onClick: onClose,
        },
        {
          text: modalContent[type].actionButtonText,
          type: "button",
          variant: "primaryDefault",
          disabled: loading,
          onClick: () => onConfirm(),
        },
      ],
    }}
  >
    {modalContent[type].content}
  </Modal>
);
